/* eslint-disable quote-props */
import { Dialog, styled } from "@mui/material";

const DialogCustom = styled(Dialog)(({ theme }) => ({
  ".MuiPaper-elevation": {
    "padding": "12px 24px 12px 24px !important",
    "width": "100%",
    "maxWidth": "302px",
    "borderRadius": "8px",
    "background": "#F9F6F4",
  },
}));

export default DialogCustom;
